// import React, { useState, useEffect } from 'react'
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import DashBoardHeader from "./dashboardHeader";
// import { getTruckDetails } from "../../storeSlices/dataSlice";
// import { getDriverDetails } from "../../storeSlices/dataSlice";
// import { getClientDetails } from "../../storeSlices/dataSlice";
import {
  Box,
  Toolbar,
  Typography,
  Drawer,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Article,
  CenterFocusStrongRounded,
  LocalShipping,
  Luggage,
  ManageAccounts,
  People,
  Person,
  Receipt,
} from "@mui/icons-material";
import "./userDashBoard.css";

const drawerWidth = 240;

const classes = {
  dashboard: {
    display: "flex",
  },
  mainContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

function UserDashboard() {
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(getTruckDetails());
  //   dispatch(getDriverDetails());
  //   dispatch(getClientDetails());
  // });
  const navigate = useNavigate();

  const navigateToHomePage = () => navigate("/dashbaord/chalan/chalans");

  const navigateTo = (path) => () => navigate(path);

  const drawerList = [
    { title: "Chalan", path: "chalan/chalans", icon: <Article /> },
    // { title: 'Manage Good', path: 'goods', icon: <Luggage /> },
    { title: "Profile", path: "profiles", icon: <Person /> },
    { title: "Manage Trucks", path: "trucks", icon: <LocalShipping /> },
    { title: "Manage Client", path: "clients", icon: <ManageAccounts /> },
    { title: "Manage Drivers", path: "drivers", icon: <People /> },
    { title: "Bilty", path: "bilty", icon: <Receipt /> },
    { title: "Invoice", path: "invoice", icon: <Receipt /> },
  ];
  return (
    <Box className="dashboard" sx={classes.dashboard}>
      <DashBoardHeader />
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="dashboard"
      >
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="permanent"
          anchor="left"
        >
          <Toolbar>
            <Typography
              variant="h5"
              component="h5"
              className="logo"
              onClick={navigateToHomePage}
            >
              LOGIBILL
            </Typography>
          </Toolbar>
          <Divider />
          <List>
            {drawerList.map((list) => (
              <ListItemButton key={list.title} onClick={navigateTo(list.path)}>
                <ListItemIcon>{list.icon}</ListItemIcon>
                <ListItemText primary={list.title} />
              </ListItemButton>
            ))}
          </List>
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Box className="content">
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default UserDashboard;
